
import glob from 'glob';
import path from 'path';
import fs from 'fs';

export default (inDir) => {
  const realDir = fs.realpathSync(path.resolve(inDir));
  return new Promise((resolve, reject) => {
    const options = {
      cwd: realDir,
      realpath: true,
      nodir: true,
    };
    glob('**', options, (err, files) =>
      ((err) ? reject(err) : resolve(files))
    );
  })
  .then(files => files.map(file => path.relative(realDir, file)));
};
